import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e907db2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Online_Audience" }
const _hoisted_2 = { class: "dudience_nav" }
const _hoisted_3 = { class: "nav_headLeft" }
const _hoisted_4 = { class: "nav_small_people" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "url_box"
}
const _hoisted_7 = ["src"]

import { Button, message, Table } from 'ant-design-vue';
import http from '@/api';
import { useConsoleStore } from '@/pinia/console';
import { useRoute } from 'vue-router';
import { nextTick, onMounted, reactive, ref, watch } from 'vue';
import { nullImg } from '@/assets';
import MList, { Column } from './MList.vue';
import { useThrottleFn } from '@vueuse/core';
/**
 * 用户禁言与黑名单对象
 */
export interface Forbidden {
  avatar: number;
  avatar_url: string;
  created_at: string;
  id: number;
  nickname: string;
  status: number;
  studio_id: number;
  uid: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ForbiddenWord',
  setup(__props) {

const aButton = Button;
const aTable = Table;
const consoleStore = useConsoleStore();
const route = useRoute();
const studioId = route.params.studioId;

const forbid = ref<Forbidden[]>([]);
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 20, // 每页条数
  totalSize: 0, // 总页数
});

const violationList = useThrottleFn((pageNum?: number) => {
  if (!pageNum && forbid.value.length >= pageConfig.totalSize) return false;
  const { current, pageSize } = pageConfig;
  http.liveInformation
    .getViolationList({
      params: {
        page: pageNum ? pageNum : current + 1,
        page_num: pageSize,
        studio_id: studioId,
        status: 1,
      },
    })
    .then((res) => {
      pageConfig.current = res.data.data.current_page;
      pageConfig.totalSize = res.data.data.total;
      if (pageNum) {
        forbid.value = res.data.data.data;
      } else {
        forbid.value = forbid.value.concat(res.data.data.data);
      }
    });
}, 500);
violationList(1);

const groupMute = (item: any) => {
  let groupMute = {
    studio_id: route.params.studioId,
    status: 0,
    avatar: item.avatar,
    monitor_id: consoleStore.consoleInfo.monitorId,
    nickname: item.nickname,
    uid: item.uid,
  };
  http.liveInformation
    .getGroupMute(groupMute)
    .then((res) => {
      message.destroy();
      message.success(res.data.message);
      // 处理筛选的数据
      forbid.value = forbid.value.filter((cur) => cur.uid !== item.uid);
      pageConfig.current = forbid.value.length / pageConfig.pageSize;
      pageConfig.totalSize--;
      // 修改成员列表数据
      consoleStore.memberList = consoleStore.memberList.map((member) => {
        if (member.uid == item.uid) {
          member.mute = 0;
        }
        return member;
      });
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
const columns: Column[] = [
  {
    title: '头像',
    dataIndex: 'url',
    align: 'center',
    slots: { customRender: 'url' },
  },
  {
    title: '昵称',
    dataIndex: 'nickname',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '禁言时间',
    ellipsis: true,
    dataIndex: 'created_at',
    align: 'center',
  },
  {
    title: '设备',
    width: '28%',
    align: 'center',
    slots: { customRender: 'equipment' },
  },
];

const mlistRef = ref<HTMLDivElement>();
const mlistHight = ref(0);

watch(forbid, (newVal) => {
  if (mlistHight.value) return;
  if (newVal.length > 0) {
    nextTick(() => {
      mlistRef.value && (mlistHight.value = mlistRef.value.offsetHeight);
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_svg_icon, {
            "icon-class": "live_chat_people",
            class: "nav_img"
          }),
          _createTextVNode(_toDisplayString(pageConfig.totalSize), 1)
        ])
      ])
    ]),
    (forbid.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "mlistRef",
          ref: mlistRef,
          class: "dudience_content"
        }, [
          _withDirectives(_createVNode(MList, {
            columns: columns,
            "data-source": forbid.value,
            "data-key": "id",
            height: mlistHight.value,
            "infinite-scroll": _unref(violationList)
          }, {
            url: _withCtx(({ record }) => [
              _createElementVNode("img", {
                src: record.avatar_url,
                alt: "",
                style: {"width":"30px","height":"30px"}
              }, null, 8, _hoisted_5)
            ]),
            equipment: _withCtx(({ record }) => [
              _createVNode(_unref(aButton), {
                class: "btn_select",
                onClick: ($event: any) => (groupMute(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("解禁")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["data-source", "height", "infinite-scroll"]), [
            [_vShow, mlistHight.value]
          ])
        ], 512))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("img", { src: _unref(nullImg) }, null, 8, _hoisted_7)
        ]))
  ]))
}
}

})